import { Avatar, AvatarFallback, AvatarImage } from "@/shared/components/ui";
import { cn, getUserInitials } from "@/shared/lib/utils";

interface UserAvatarProps {
  name: string;
  avatarUrl?: string | null;
  className?: string;
  fallbackClassName?: string;
}

export function UserAvatar({ name, avatarUrl, className, fallbackClassName }: UserAvatarProps) {
  return (
    <Avatar className={className}>
      {avatarUrl ? (
        <AvatarImage src={avatarUrl} alt={name} referrerPolicy="no-referrer" />
      ) : null}
      <AvatarFallback className={cn("bg-visagio-mint text-visagio-teal", fallbackClassName)}>
        {getUserInitials(name)}
      </AvatarFallback>
    </Avatar>
  );
}
